import { Typography } from "@jewlr/storybook/core"
import styled from "styled-components"

export const KlarnaTitle = styled(Typography).attrs((props) => ({
  as: "h3",
  fontSize: 18,
  marginTop: props.subtitle ? { _: 1, tablet: 2 } : "",
  mb: props.theme.paymentPlans.klarna.klarnaTitle.mb,
  pb: 2,
  textAlign: "center",
}))`
  background: linear-gradient(
    transparent,
    ${(props) => props.theme.paymentPlans.klarna.klarnaTitle.bg}
  );
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 28% 1px;
  ${(props) => props.theme.mediaQueries.tablet`
     background-size: 10% 1px;
  `}
`
export const TextLink = styled(Typography).attrs({
  as: "a",
  color: "primary",
})`
  text-decoration: underline;
`
export const Question = styled(Typography).attrs({
  as: "h1",
  fontSize: { _: "14px", tablet: "16px" },
  mb: 2,
})``
